import React from 'react';
import SiteHead from "../SiteHead";
import Spinner from 'react-bootstrap/Spinner';


export const LoadingText = ({ site }) => (
  <>
    <SiteHead title="EarningsCall · XXXXXXXXXX" description={`XXXXXXXXXXX`} />
    <section className="common-hero-section">
      <div className="container">
        <div className="hero-content">
          <h1 className="title">
            Loading Page
            <Spinner
              as="span"
              animation="grow"
              role="status"
              aria-hidden="true"
            />
          </h1>
        </div>
      </div>
    </section>
  </>
);
